import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import Layout from "./Layout";
import Loading from "@components/Statuses/Loading";
import Fail from "@components/Statuses/Fail";
import Button from "@components/Button";

const CodePage = lazy(() => import("@pages/CodePage"));
const NotFound = lazy(() => import("@pages/NotFound"));
const CampaignNotFound = lazy(() => import("@pages/CampaignNotFound"));
const LoginPage = lazy(() => import("@pages/LoginPage"));
const VerifyPage = lazy(() => import("@pages/VerifyPage"));
// const YotiPage = lazy(() => import("@pages/VerifyPage/YotiPage"));
const PersonalDetailsPage = lazy(() => import("@pages/VerifyPage/PersonalDetailsPage"));
const SchufaPage = lazy(() => import("@pages/VerifyPage/SchufaPage"));
const SurveyPage = lazy(() => import("@pages/VerifyPage/SurveyPage"));
const OffersPage = lazy(() => import("@pages/Offers"));
const NoOffersPage = lazy(() => import("@pages/NoOffers"));
const Offer = lazy(() => import("@pages/Offer"));
const YourOffer = lazy(() => import("@pages/YourOffer"));
const PhoneNumberBypass = lazy(() => import("@pages/VerifyPage/PhoneNumber"));

function Router() {
  class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, error: "", errorInfo: "" };
    }

    static getDerivedStateFromError(error) {
      return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
      this.setState({ error: error, errorInfo: errorInfo })
    }

    render() {
      if (this.state.hasError) {
        return <div className="error-boundary">
          <Fail>
            <h2>Something went wrong.</h2>
            <p dangerouslySetInnerHTML={{ __html: (this.state.error) }}></p>
            {/* <p dangerouslySetInnerHTML={{ __html: (this.state.errorInfo?.componentStack)?.replaceAll("\n", "<br/>") }}></p> */}
            <p><strong>Path:</strong> {document.location.href}</p>
            <p><strong>UserAgent:</strong> {navigator.userAgent}</p>
            <p><strong>App version ID:</strong> {import.meta.env.VITE_COMMIT_ID}</p>
            {document.querySelector("html.translated-ltr, html.translated-rtl, ya-tr-span, *[_msttexthash], *[x-bergamot-translated]") ? <p><strong translate="no">Please try again without a translator!</strong></p> : null}
            <Button action={() => { location.reload() }}>Seite neu laden</Button>
          </Fail>
        </div>
      }

      return this.props.children;
    }
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading fullScreen>
        <p>Gib uns einen Augenblick</p>
      </Loading>}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="code" element={<CodePage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="login/:otp" element={<LoginPage />} />
            <Route path="verify" element={<VerifyPage />} >
              <Route path="personal-details" element={<PersonalDetailsPage />} />
              {/* <Route path="yoti" element={<YotiPage />} /> */}
              <Route path="schufa" element={<SchufaPage />} />
              <Route path="survey" element={<SurveyPage />} />
              <Route path="phone" element={<PhoneNumberBypass />} />
              <Route path="phone/:otp" element={<PhoneNumberBypass />} />
            </Route>
            <Route path="offers" element={<OffersPage />} />
            <Route path="no-offers" element={<NoOffersPage />} />
            <Route path="offer" element={<Offer />} />
            <Route path="offer/:module" element={<Offer />} />
            <Route path="offer/:offer/:module" element={<Offer />} />
            <Route path="offer/:offer/:module/:otp" element={<Offer />} />
            <Route path="coupon" element={<YourOffer />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="*" element={<CampaignNotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default Router
